import { query } from "../../../erd-editor-schema/dist/query/index.js";
import { arrayHas } from "../../../utils/arrayHas.js";
import { createAction } from "../../../r-html/dist/store/index.js";
import { POSITION_REGISTER, SIZE_REGISTER, isOwnStep } from "../../geometryRegisters.js";
import { ActionType } from "./actions.js";
import { createTableGroup } from "../../../utils/collection/tableGroup.entity.js";
import { isString } from "es-toolkit";
import { round } from "es-toolkit/compat";
//#region src/engine/modules/table-group/atom.actions.ts
var addTableGroupAction = createAction(ActionType.addTableGroup);
var addTableGroup = ({ doc, collections, lww }, { payload: { id, color, ui }, version }, { clock }) => {
	const safeVersion = version ?? clock.getVersion();
	query(collections).collection("tableGroupEntities").addOne(createTableGroup({
		id,
		ui,
		...isString(color) ? { color } : {}
	})).addOperator(lww, safeVersion, id, () => {
		if (!arrayHas(doc.tableGroupIds)(id)) doc.tableGroupIds.push(id);
	});
};
var moveTableGroupAction = createAction(ActionType.moveTableGroup);
var moveTableGroup = ({ collections, lww }, { payload: { ids, movementX, movementY }, version, tags }, context) => {
	const collection = query(collections).collection("tableGroupEntities");
	for (const id of ids) collection.getOrCreate(id, (id) => createTableGroup({ id }));
	const step = (group) => {
		group.ui.x = round(group.ui.x + movementX, 4);
		group.ui.y = round(group.ui.y + movementY, 4);
	};
	if (!isOwnStep(context, tags)) {
		collection.updateMany(ids, step);
		return;
	}
	const safeVersion = version ?? context.clock.getVersion();
	for (const id of ids) collection.replaceOperator(lww, safeVersion, id, POSITION_REGISTER, () => {
		collection.updateOne(id, step);
	});
};
var moveToTableGroupAction = createAction(ActionType.moveToTableGroup);
var moveToTableGroup = ({ collections, lww }, { payload: { id, x, y }, version }, { clock }) => {
	const safeVersion = version ?? clock.getVersion();
	const collection = query(collections).collection("tableGroupEntities");
	collection.getOrCreate(id, (id) => createTableGroup({ id }));
	collection.replaceOperator(lww, safeVersion, id, POSITION_REGISTER, () => {
		collection.updateOne(id, (group) => {
			group.ui.x = x;
			group.ui.y = y;
		});
	});
};
var removeTableGroupAction = createAction(ActionType.removeTableGroup);
var removeTableGroup = ({ doc, collections, lww }, { payload: { id }, version }, { clock }) => {
	const safeVersion = version ?? clock.getVersion();
	query(collections).collection("tableGroupEntities").removeOperator(lww, safeVersion, id, () => {
		const index = doc.tableGroupIds.indexOf(id);
		if (index !== -1) doc.tableGroupIds.splice(index, 1);
	});
};
var resizeTableGroupAction = createAction(ActionType.resizeTableGroup);
var resizeTableGroup = ({ collections, lww }, { payload: { id, x, y, width, height }, version }, { clock }) => {
	const safeVersion = version ?? clock.getVersion();
	const collection = query(collections).collection("tableGroupEntities");
	collection.getOrCreate(id, (id) => createTableGroup({ id }));
	collection.replaceOperator(lww, safeVersion, id, POSITION_REGISTER, () => {
		collection.updateOne(id, (group) => {
			group.ui.x = x;
			group.ui.y = y;
		});
	}).replaceOperator(lww, safeVersion, id, SIZE_REGISTER, () => {
		collection.updateOne(id, (group) => {
			group.ui.width = width;
			group.ui.height = height;
		});
	});
};
var changeTableGroupNameAction = createAction(ActionType.changeTableGroupName);
var changeTableGroupName = ({ collections, lww }, { payload: { id, value }, version }, { clock }) => {
	const safeVersion = version ?? clock.getVersion();
	const collection = query(collections).collection("tableGroupEntities");
	collection.getOrCreate(id, (id) => createTableGroup({ id }));
	collection.replaceOperator(lww, safeVersion, id, "name", () => {
		collection.updateOne(id, (group) => {
			group.name = value;
		});
	});
};
var changeTableGroupColorAction = createAction(ActionType.changeTableGroupColor);
var changeTableGroupColor = ({ collections, lww }, { payload: { id, color }, version }, { clock }) => {
	const safeVersion = version ?? clock.getVersion();
	const collection = query(collections).collection("tableGroupEntities");
	collection.getOrCreate(id, (id) => createTableGroup({ id }));
	collection.replaceOperator(lww, safeVersion, id, "color", () => {
		collection.updateOne(id, (group) => {
			group.color = color;
		});
	});
};
var changeTableGroupZIndexAction = createAction(ActionType.changeTableGroupZIndex);
var changeTableGroupZIndex = ({ collections }, { payload: { id, zIndex } }) => {
	const collection = query(collections).collection("tableGroupEntities");
	collection.getOrCreate(id, (id) => createTableGroup({ id }));
	collection.updateOne(id, (group) => {
		group.ui.zIndex = zIndex;
	});
};
var tableGroupReducers = {
	[ActionType.addTableGroup]: addTableGroup,
	[ActionType.moveTableGroup]: moveTableGroup,
	[ActionType.moveToTableGroup]: moveToTableGroup,
	[ActionType.removeTableGroup]: removeTableGroup,
	[ActionType.resizeTableGroup]: resizeTableGroup,
	[ActionType.changeTableGroupName]: changeTableGroupName,
	[ActionType.changeTableGroupColor]: changeTableGroupColor,
	[ActionType.changeTableGroupZIndex]: changeTableGroupZIndex
};
var actions = {
	addTableGroupAction,
	moveTableGroupAction,
	moveToTableGroupAction,
	removeTableGroupAction,
	resizeTableGroupAction,
	changeTableGroupNameAction,
	changeTableGroupColorAction,
	changeTableGroupZIndexAction
};
//#endregion
export { actions, addTableGroupAction, changeTableGroupColorAction, changeTableGroupNameAction, changeTableGroupZIndexAction, moveTableGroupAction, moveToTableGroupAction, removeTableGroupAction, resizeTableGroupAction, tableGroupReducers };
